import { render } from "./AdminNotificationList.vue?vue&type=template&id=268455bd&scoped=true"
import script from "./AdminNotificationList.vue?vue&type=script&lang=js"
export * from "./AdminNotificationList.vue?vue&type=script&lang=js"

import "./AdminNotificationList.vue?vue&type=style&index=0&id=268455bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268455bd"]])

export default __exports__